/**
 * Aktiviert dynamische Breakpoint-Klassen für Cover-Blöcke mit Custom-Breakpoints.
 * Wird nur ausgeführt wenn mindestens ein Block mit data-cover-mobile-*-bp vorhanden ist.
 *
 * CSS-Klassen die gesetzt/entfernt werden:
 *   is-mobile-aspect-bp-active  → wenn Viewport ≤ data-cover-mobile-aspect-bp
 *   is-mobile-height-bp-active  → wenn Viewport ≤ data-cover-mobile-height-bp
 */
export function initCoverMobileBreakpoints() {
    const covers = document.querySelectorAll(
        '.wp-block-cover[data-cover-mobile-aspect-bp], .wp-block-cover[data-cover-mobile-height-bp]'
    );

    if (!covers.length) return;

    const update = () => {
        const vw = window.innerWidth;
        covers.forEach((cover) => {
            const aspectBp = parseInt(cover.dataset.coverMobileAspectBp, 10);
            if (!isNaN(aspectBp)) {
                cover.classList.toggle('is-mobile-aspect-bp-active', vw <= aspectBp);
            }

            const heightBp = parseInt(cover.dataset.coverMobileHeightBp, 10);
            if (!isNaN(heightBp)) {
                cover.classList.toggle('is-mobile-height-bp-active', vw <= heightBp);
            }
        });
    };

    update();
    new ResizeObserver(update).observe(document.documentElement);
}
